import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

export const numeral = defineConnector({
  identifier: "numeral",
  name: "Numeral",
  tagLine: "Finance operations and payout automation",
  logo,
  protocol: "http",
  tags: ["data"],
  auth: (app) => headerAuth([{ name: "x-api-key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Create a Numeral API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Numeral, create an API key and send it in the `x-api-key` header for API requests.",
        },
      ],
    },
    {
      title: "Enter your Numeral details",
      items: [
        {
          kind: "baseUrl",
          label: "Numeral base URL",
          required: true,
          placeholder: "https://sandbox.numeral.io",
          target: { kind: "configuration", field: "instanceUrl" },
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) =>
      `${instanceUrl || "https://sandbox.numeral.io"}/v1/payment_orders`,
  },
  defaultUrlPattern: ({ instanceUrl }) =>
    urlToPattern(instanceUrl, "https://[^/]*\\.numeral\\.io/.*"),
});
